import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs';

import type { ScreenFlags } from '../models/screen-flags';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveDetectionService {
  breakpointObserver = inject(BreakpointObserver);

  screenFlags$: Observable<ScreenFlags> = this.breakpointObserver
    .observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge,
    ])
    .pipe(
      map((result) => {
        const BREAKPOINT = result.breakpoints;
        return {
          isMobile: BREAKPOINT[Breakpoints.XSmall] || false,
          isTablet: BREAKPOINT[Breakpoints.Small] || false,
          isLaptop: BREAKPOINT[Breakpoints.Medium] || false,
          isDesktop: BREAKPOINT[Breakpoints.Large] || BREAKPOINT[Breakpoints.XLarge] || false,
        };
      }),
      shareReplay(1)
    );
}
